export type Testimonial = {
  id: number;
  name: string;
  handle: string;
  content: string;
  avatar: string;
  rating: number;
  isVerified: boolean;
};

type ApiTestimonial = {
  TestimonialId: string | number;
  CustomerName: string;
  CustomerHandle?: string | null;
  Content: string;
  Rating?: number;
  AvatarUrl?: string | null;
  IsVerified?: boolean;
};

type ApiResponse<T> = T & { ok: boolean; message?: string };

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || "資料載入失敗，請稍後再試。");
  }
  return data as T;
}

function normalize(item: ApiTestimonial): Testimonial {
  return {
    id: Number(item.TestimonialId),
    name: item.CustomerName || "",
    handle: item.CustomerHandle || "",
    content: item.Content || "",
    avatar: item.AvatarUrl || "",
    rating: Number(item.Rating || 5),
    isVerified: item.IsVerified === true,
  };
}

/**
 * 供前台首頁「使用者好評」區塊使用。
 * 若 API 尚未部署、失敗，或後台目前沒有任何上架中的好評，回傳空陣列，讓呼叫端可以自行決定是否退回預設內容。
 */
export async function fetchPublicTestimonials(): Promise<Testimonial[]> {
  try {
    const data = await fetch("/api/testimonials", {
      credentials: "include",
      headers: { Accept: "application/json" },
    }).then((response) => parseJsonResponse<{ ok: boolean; Testimonials: ApiTestimonial[] }>(response));
    return (data.Testimonials || []).map(normalize);
  } catch {
    return [];
  }
}
